import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';

import { UserService } from 'app/services';

export const userProfileRoleGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const userService = inject(UserService);
    const isAdminProfile = !!route.data['adminProfile'];
    userService.setIsAdminProfile(isAdminProfile);
    return true;
};
